import {
    EDITDEALERLIST_SUCCESS,
    EDITDEALERLIST_FAILED,
    RESET_EDITDEALERLIST,
    LOADING_EDITDEALERLIST,
    NETWORK_ERROR_EDITDEALERLIST
} from "../types/index";

import { partnerServices } from "../../config/axios";

const resetEditDealerListForPartner = () => {
    return { type: RESET_EDITDEALERLIST };
};


const partnerEditDealerListReq = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_EDITDEALERLIST });
    await partnerServices
        .post("editDealerList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerEditDealerListsuccess(res.data));
                    break;
                default:
                    dispatch(partnerEditDealerListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_EDITDEALERLIST,
                payload: err
            });
        });
};


function partnerEditDealerListsuccess(data) {
    return {
        type: EDITDEALERLIST_SUCCESS,
        payload: data,
    };
}

function partnerEditDealerListFailed(data) {
    return {
        type: EDITDEALERLIST_FAILED,
        payload: data,
    };
}
export { resetEditDealerListForPartner, partnerEditDealerListReq }